import cookies from 'js-cookie';

import {
    getName,
    safeJSONParse,
    removeCookie,
    getNextViewPil,
    getNextHrefPil,
} from '../helpers/helpers';
import type { ICookieInit } from '../models';
import { showForm } from '../config';

import { BaseCookie } from './base';

// TODO: вынести в командную папку
export class PilCookie extends BaseCookie {
    constructor({ cookieName = 'pil-draft', products = [], setState }: ICookieInit) {
        super({ cookieName, products, setState });
        setState(showForm);
    }

    deleteCookie(cookieName: string) {
        removeCookie(cookieName);
        this.setState(state => ({
            ...state,
            ...showForm,
        }));
    }

    parseCookie() {
        const pilThanksCookie = safeJSONParse(cookies.get('pil-thanks'));

        if (!this.parsedCookie && !pilThanksCookie) return;

        const {
            draftId = '',
            firstName,
            middleName,
            predodob,
        } = pilThanksCookie || this.parsedCookie;

        const hasName = firstName && middleName;
        const hasPreApprovedOffers = predodob > 0;
        const nextView = getNextViewPil(!!pilThanksCookie, hasPreApprovedOffers);
        const href = getNextHrefPil(draftId, !!pilThanksCookie, hasPreApprovedOffers);

        this.setState({
            predodob,
            href,
            text: hasName ? getName(firstName, middleName) : '',
            onRemove: () => this.deleteCookie(pilThanksCookie ? 'pil-thanks' : 'pil-draft'),
            ...nextView,
        });
    }
}
